module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"works":"Works","go_there":"Show page","functions":"Functions","additional_functions":"Additional functions"},"cs":{"works":"Díla","go_there":"Zobrazit stránku","functions":"Funkce","additional_functions":"Doplňkové funkce"}}')
  delete Component.options._Ctor
}
